import Component from '@glimmer/component';

import { service } from '@ember/service';

import SearchFilters from 'rise-ui/components/search-filters.gjs';

export default class TimeSeriesSearchFiltersComponent extends Component {
  @service('time-series/search') search;

  <template>
    <SearchFilters
      @route={{this.search.linkToCommit}}
      @filters={{this.search.filters}}
      @selection={{this.search.editedFilters}}
      @refresh={{this.search.isDirty}}
      @action={{this.search.editFilterByKey}}
    />
  </template>
}
